import React, {useRef, useState} from "react"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import Switch from "react-bootstrap-switch";
import {
    Card, CardBody, CardTitle, Col, Form,
    FormGroup, Label, Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap"


// components
import LangPromotionActivity from "./_langs";
import Separator from "../../../components/Separator";
import NotificationLangs from "../../comunication/notification/_langs";
import { GenericButton } from "../../../components/buttons/customButtons";
import TranslateButton from "../../../components/buttons/TranslateButton";
import { GenericTableButton } from "../../../components/buttons/buttonsActions";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";
import ModalFormTitle from "../../../components/genericComponents/ModalFormTitle";
import promotionActivityComponent from "../../../components/promotion/PromotionActivityComponent";
import Loading from "../../../components/loader/Loading";
import SchedulePromotion from "./schedule/SchedulePromotion";


// labels
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";


// services
import {promotionActivityService} from "../../../jwt/_services/promotions/promotionActivityService"


// utils
import {getStateByPath} from "../../../redux/selectors";
import {getCurrentDateForCodeField} from "../../../util/DateTools";


// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";




const PromotionActivityForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const {path} = componentState;
    const {app, editMode, domainObject, loading} = componentState?.data;

    const [activeTab, setActiveTab] = useState(1)


    const {
        component,
        udn,
        activity,
        discountMount,
        discountPercentage
    } = promotionActivityComponent(path)



    const {fbDataBase} = app
    const translatableLangs = domainObject?.translatedLangs || []

    const [isActive, setIsActive] = useState(domainObject?.isActive || true);
    const [showPrices, setShowPrices] = useState(domainObject?.showPrices || true);
    const [isRecurring, setIsRecurring] = useState(domainObject?.isRecurring || false);
    const [applyOnlyToCreationDate, setApplyOnlyToCreationDate] = useState(domainObject?.applyOnlyToCreationDate || true);
    const [isFullDate, setIsFullDate] = useState(domainObject?.isFullDate || false);
    const [schedules, setSchedules] = useState(domainObject?.schedules || []);


    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [notificationLangs, setNotificationLangs] = useState(domainObject?.notification?.langs || []);
    const [showModal, setShowModal] = useState(true)


    const modalRef = useRef(null);


    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }



    const { handleSubmit, reset } = useForm({
        defaultValues: {
            id: domainObject?.id,
            code: domainObject?.code,
            monto: domainObject?.monto,
            porcentaje: domainObject?.porcentaje,
        }
    });


    const onSubmit = (data, e, notify) => {
        if(schedules.length === 0)
            return alert('Debe agregar al menos un horario para la promoción.')

        const schedulesWithError = schedules.filter( sch => sch?.hasError );
        
        if(schedulesWithError.length > 0)
            return alert('Hay errores en los horarios de la promoción. Por favor verifique.')
        
        if(!activity)
            return alert('No se ha podido determinar la actividad a la cual se le aplicará la promoción.')


        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                langs,
                notify,
                code:`${app?.code}_${activity?.id}_${getCurrentDateForCodeField()}`,
                activity:{ id:activity?.id },
                monto:discountMount,
                porcentaje:Number(discountPercentage),
                notification:{
                    applicative: { id: app?.id },
                    langs: notificationLangs,
                },
                isActive,
                showPrices,
                isRecurring,
                isFullDate,
                applyOnlyToCreationDate,
                schedules,
            }
        };


        if (!editMode)
            genericIndexedActions.save(path, promotionActivityService, dataRequest, closeForm)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id
            dataRequest.item.notification.id = domainObject?.notification?.id

            genericIndexedActions.update(path, promotionActivityService, id, dataRequest, closeForm)
        }
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }


    const onChangeActiveTab = tab => setActiveTab(tab);


    const onChangeData = (type, value) => {
        switch (type) {
            case 'IS_RECURRING':
                setIsRecurring(value)
                break;

            case 'APPLY_ONLY_TO_CREATION_DATE':
                setApplyOnlyToCreationDate(value)
                break;

            case 'IS_FULL_DAY':
                setIsFullDate(value)
                break;

            case 'SCHEDULE':
                setSchedules(value)
                break;
        }
    }



    return <Form onSubmit={ e => handleSubmit( data => onSubmit(data, e, false))(e) }>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <ModalFormTitle
                    domainObject={domainObject}
                    editMode={editMode}
                    udn={udn}
                />

                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                            <TranslateButton item={domainObject} service={promotionActivityService} />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>

                {
                    loading && <Loading isLoading={true} title={ 'Procesando...' }/>
                }


                {component()}

                <br/>


                <FormGroup row>
                    <Label sm={6}>{'¿La Promoción esta Activa?'}</Label>
                    <Col>
                        <Switch
                            animate={true}
                            onText={"Si"}
                            offText={"No"}
                            value={isActive}
                            onChange={() => setIsActive(!isActive)}
                        />
                    </Col>
                </FormGroup>

                <FormGroup row>
                    <Label sm={6}>{'¿La Promoción debe mostrar precios en pantalla?'}</Label>
                    <Col>
                        <Switch
                            animate={true}
                            onText={"Si"}
                            offText={"No"}
                            value={showPrices}
                            onChange={() => setShowPrices(!showPrices)}
                        />
                    </Col>
                </FormGroup>




                <SchedulePromotion
                    path={path}
                    udn= {udn}
                    onChangeData={onChangeData}
                />


                <div>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={activeTab === 1 ? 'active' : ''}
                                onClick={() => onChangeActiveTab(1)}>
                                    <i className="fas fa-language mr-2"/>
                                    {`Descripción de la Promoción`}
                            </NavLink>
                        </NavItem>


                        <NavItem>
                            <NavLink
                                className={activeTab === 2 ? 'active' : ''}
                                onClick={() => onChangeActiveTab(2)}>
                                    <i className="fas fa-language mr-2"/>
                                    {`Descripción de la Notificación`}
                            </NavLink>
                        </NavItem>
                    </Nav>

                    <TabContent activeTab={ activeTab }>
                        <TabPane tabId={1}>
                            <br/>
                            <br/>
                            <LangPromotionActivity
                                langs={langs}
                                setLangs={setLangs}
                                translatableLangs={translatableLangs}
                            />
                        </TabPane>
                        <TabPane tabId={2}>
                            <br/>
                            <br/>
                            <NotificationLangs
                                langs={notificationLangs}
                                setLangs={setNotificationLangs}
                            />

                            <div className={'float-right'}>
                                <GenericButton
                                    clazzName={'round-button'}
                                    style={'table'}
                                    toolTip={'Notificar'}
                                    icon={'fa fa-paper-plane-o'}
                                    permission={'edit'}
                                    onClick={e => handleSubmit(data => onSubmit(data, e, true))(e)}
                                />
                            </div>
                        </TabPane>
                    </TabContent>
                </div>

            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}
export default PromotionActivityForm